import type { GameState } from "@/game/types";
import { formatSats } from "@/game/format";
import { averageHealth } from "@/game/engine";
import { Coins, Drumstick, HeartPulse, Wrench, Pill, CalendarDays } from "lucide-react";

interface StatChipProps {
  icon: React.ReactNode;
  label: string;
  value: string;
}

function StatChip({ icon, label, value }: StatChipProps) {
  return (
    <div className="flex items-center gap-2 rounded-md bg-secondary/70 px-3 py-2">
      <span className="text-primary">{icon}</span>
      <div className="leading-none">
        <div className="font-pixel text-[8px] uppercase tracking-wider text-muted-foreground">
          {label}
        </div>
        <div className="font-terminal text-lg leading-none">{value}</div>
      </div>
    </div>
  );
}

export function StatusBar({ state }: { state: GameState }) {
  const avg = averageHealth(state.party);
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-6">
      <StatChip
        icon={<Coins className="size-4" />}
        label="Sats"
        value={formatSats(state.inventory.sats)}
      />
      <StatChip
        icon={<Drumstick className="size-4" />}
        label="Food"
        value={String(state.inventory.food)}
      />
      <StatChip
        icon={<Pill className="size-4" />}
        label="Med Kits"
        value={String(state.inventory.medicine)}
      />
      <StatChip
        icon={<Wrench className="size-4" />}
        label="Gear"
        value={String(state.inventory.gear)}
      />
      <StatChip
        icon={<HeartPulse className="size-4" />}
        label="Health"
        value={`${avg}%`}
      />
      <StatChip
        icon={<CalendarDays className="size-4" />}
        label="Day"
        value={String(state.day)}
      />
    </div>
  );
}
